import { css } from 'styled-components';

export const e24Theme = css`
    --color-primary: #4326C8;

    --color-state-primary: rgba(67, 38, 200, 0.07);
    --color-state-secondary: rgba(67, 38, 200, 0.24);
    --color-state-tertiary: rgba(48, 49, 48, 0.07);

    --color-outline: rgba(67, 38, 200, 1);

    /* Home Page */
    --home-hero-background: #4326C8;
    --home-hero-title-color: white;
    --home-hero-subtitle-color: white;

    /* Subscription Page */
    --subscription-hero-background: #FFF6EF;
    --subscription-hero-title-color: black;
    --subscription-hero-subtitle-color: black;

    /* User Shortcuts */
    --color-outline-accent: var(--color-primary);

`;
